import React from 'react';

export type ToastMessage = {
  text: string;
};

export default function Toast({
  message,
  onDone,
  ms = 1800,
}: {
  message: ToastMessage | null;
  onDone: () => void;
  ms?: number;
}) {
  React.useEffect(() => {
    if (!message) return;
    const t = window.setTimeout(() => onDone(), ms);
    return () => window.clearTimeout(t);
  }, [message, ms, onDone]);

  if (!message) return null;

  return (
    <div className="toast" role="status" aria-live="polite">
      {message.text}
    </div>
  );
}
